import { defineAsyncComponent } from 'vue'
export default {
  "advisor-app": defineAsyncComponent(() => import("/app/app/layouts/advisor-app.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  "developer-menu": defineAsyncComponent(() => import("/app/app/layouts/developer-menu.vue").then(m => m.default || m)),
  embed: defineAsyncComponent(() => import("/app/app/layouts/embed.vue").then(m => m.default || m)),
  "my-benefit-demo": defineAsyncComponent(() => import("/app/app/layouts/my-benefit-demo.vue").then(m => m.default || m)),
  print: defineAsyncComponent(() => import("/app/app/layouts/print.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/app/app/layouts/simple.vue").then(m => m.default || m))
}